import { isPasswordValid } from './isPasswordValid'

const validatePresence = value => {
  if (!value) return false
  return value.length > 0
}

const validatePassword = value => {
  if (!value) return false
  return isPasswordValid({ value, requiredLength: 8 })
}

const ruleMap = {
  presence: (field, value) => {
    return { isValid: validatePresence(value), message: `${field} is required` }
  },
  password: (_, value) => {
    return {
      isValid: validatePassword(value),
      message: `Password must contain at least one number, one uppercase letter, one lowercase letter, and be at least 8 characters in length`,
    }
  },
}

export const clearFormErrors = () => {
  return {}
}

export const validateForm = fields => {
  const errors = clearFormErrors()

  Object.entries(fields).map(([field, current], _) => {
    const { rules, value } = current
    rules.map(rule => {
      const { isValid, message } = ruleMap[rule](field, value)
      if (!isValid) {
        errors[field] = message
      }
    })
  })
  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  }
}
